import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import axios from 'axios';

const API = 'https://app.b3rastreamento.com.br/api';

function Parceiros() {
  const [sidebarAberta, setSidebarAberta] = useState(false);
  const [parceiros, setParceiros] = useState([]);
  const [modalAberto, setModalAberto] = useState(false);
  const [salvando, setSalvando] = useState(false);
  const [busca, setBusca] = useState('');
  const [form, setForm] = useState({
    nome: '', codigo: '', cor_primaria: '#1D9E75', logo_url: '',
    email_admin: '', senha_admin: '', nome_admin: '',
    telefone: '', email: '',
    razao_social: '', documento: '', cep: '', endereco: '',
    numero: '', complemento: '', bairro: '', cidade: '', estado: ''
  });
  const [uploadandoLogo, setUploadandoLogo] = useState(false);
  const [dragOver, setDragOver] = useState(false);
  const [editando, setEditando] = useState(null);

  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => { carregarParceiros(); }, []);

  const uploadLogo = async (arquivo) => {
    if (!arquivo) return;
    setUploadandoLogo(true);
    try {
      const formData = new FormData();
      formData.append('logo', arquivo);
      const res = await axios.post(`${API}/upload/logo`, formData, {
        headers: { ...headers, 'Content-Type': 'multipart/form-data' }
      });
      setForm(prev => ({ ...prev, logo_url: res.data.url }));
    } catch (err) {
      alert('Erro ao enviar logo. Máximo 2MB, formato JPG/PNG/SVG.');
    }
    setUploadandoLogo(false);
  };

  const buscarCep = async (cep) => {
    const c = cep.replace(/\D/g, '');
    if (c.length === 8) {
      const res = await fetch(`https://viacep.com.br/ws/${c}/json/`);
      const data = await res.json();
      if (!data.erro) setForm(f => ({ ...f, endereco: data.logradouro, bairro: data.bairro, cidade: data.localidade, estado: data.uf }));
    }
  };

  const carregarParceiros = async () => {
    try {
      const res = await axios.get(`${API}/parceiros`, { headers });
      setParceiros(res.data);
    } catch (err) { console.error(err); }
  };

  const salvar = async () => {
    if (!form.nome) return alert('Nome do parceiro é obrigatório!');
    if (!form.codigo) return alert('Código de acesso é obrigatório!');
    if (!editando) {
      if (!form.email_admin) return alert('Email do administrador é obrigatório!');
      if (!form.senha_admin) return alert('Senha do administrador é obrigatória!');
      if (!form.nome_admin) return alert('Nome do administrador é obrigatório!');
    }
    setSalvando(true);
    try {
      if (editando) {
        await axios.put(`${API}/parceiros/${editando.id}`, {
          nome: form.nome, codigo: form.codigo, cor_primaria: form.cor_primaria,
          logo_url: form.logo_url, email: form.email, telefone: form.telefone
        }, { headers });
        alert('✅ Parceiro atualizado com sucesso!');
      } else {
        await axios.post(`${API}/parceiros`, form, { headers });
        alert('✅ Parceiro criado com sucesso!');
      }
      fecharModal();
      carregarParceiros();
    } catch (err) {
      alert(err.response?.data?.erro || 'Erro ao salvar parceiro');
    }
    setSalvando(false);
  };

  const abrirEditar = (p) => {
    setEditando(p);
    setForm({
      nome: p.nome || '',
      codigo: p.codigo || '',
      cor_primaria: p.cor_primaria || '#1D9E75',
      logo_url: p.logo_url || '',
      email: p.email || '',
      telefone: p.telefone || '',
      razao_social: p.razao_social || '',
      documento: p.documento || '',
      cep: p.cep || '',
      endereco: p.endereco || '',
      numero: p.numero || '',
      complemento: p.complemento || '',
      bairro: p.bairro || '',
      cidade: p.cidade || '',
      estado: p.estado || '',
      email_admin: '', senha_admin: '', nome_admin: ''
    });
    setModalAberto(true);
  };

  const alterarStatus = async (id, ativo) => {
    if (!window.confirm(`Deseja ${ativo ? 'inativar' : 'reativar'} este parceiro?`)) return;
    try {
      await axios.patch(`${API}/parceiros/${id}/status`, { ativo: !ativo }, { headers });
      carregarParceiros();
    } catch (err) { alert('Erro ao alterar status'); }
  };

  const fecharModal = () => {
    setModalAberto(false);
    setEditando(null);
    setForm({ nome: '', codigo: '', cor_primaria: '#1D9E75', logo_url: '', email_admin: '', senha_admin: '', nome_admin: '', telefone: '', email: '', razao_social: '', documento: '', cep: '', endereco: '', numero: '', complemento: '', bairro: '', cidade: '', estado: '' });
  };

  const parceirosFiltraados = parceiros.filter(p =>
    p.nome?.toLowerCase().includes(busca.toLowerCase()) ||
    p.codigo?.toLowerCase().includes(busca.toLowerCase())
  );

  const inputStyle = { width: '100%', padding: '10px 12px', border: '1.5px solid #e0e0e0', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box', outline: 'none' };
  const labelStyle = { display: 'block', marginBottom: '4px', color: '#555', fontSize: '13px', fontWeight: '500' };

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5' }}>
      <Sidebar aberta={sidebarAberta} setAberta={setSidebarAberta} />

      <div style={{ background: '#1D9E75', padding: '0 24px', height: '60px', display: 'flex', alignItems: 'center', gap: '16px', position: 'fixed', top: 0, left: 0, right: 0, zIndex: 50, boxShadow: '0 2px 10px rgba(0,0,0,0.2)' }}>
        <button onClick={() => setSidebarAberta(!sidebarAberta)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '22px', color: 'white' }}>☰</button>
        <span style={{ color: 'white', fontWeight: '700', fontSize: '18px' }}>🤝 Parceiros White-Label</span>
        <span style={{ color: 'rgba(255,255,255,0.7)', fontSize: '14px' }}>({parceiros.length} cadastrados)</span>
      </div>

      <div style={{ paddingTop: '80px', padding: '80px 24px 24px' }}>
        <div style={{ background: '#E1F5EE', borderRadius: '8px', padding: '12px 16px', marginBottom: '20px', fontSize: '13px', color: '#0F6E56' }}>
          🤝 <strong>Parceiros White-Label</strong> — Cada parceiro tem seu próprio ambiente isolado com código de acesso, logo e cor personalizados. Os dados dos parceiros não se misturam entre si.
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <input placeholder="🔍 Buscar por nome ou código..." value={busca} onChange={e => setBusca(e.target.value)} style={{ ...inputStyle, width: '400px' }} />
          <button onClick={() => setModalAberto(true)} style={{ background: '#1D9E75', color: 'white', border: 'none', borderRadius: '8px', padding: '10px 20px', cursor: 'pointer', fontSize: '14px', fontWeight: '600' }}>+ Novo Parceiro</button>
        </div>

        <div style={{ background: 'white', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#f8f8f8' }}>
                {['Cor', 'Nome', 'Código', 'Email', 'Telefone', 'Clientes', 'Status', 'Ações'].map(h => (
                  <th key={h} style={{ padding: '14px 16px', textAlign: 'left', fontSize: '13px', color: '#666', fontWeight: '600', borderBottom: '1px solid #eee' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {parceirosFiltraados.length === 0 ? (
                <tr><td colSpan="8" style={{ padding: '48px', textAlign: 'center', color: '#999' }}>
                  <div style={{ fontSize: '48px', marginBottom: '12px' }}>🤝</div>
                  <div>Nenhum parceiro cadastrado</div>
                  <div style={{ fontSize: '13px', marginTop: '8px', color: '#bbb' }}>Clique em "+ Novo Parceiro" para começar</div>
                </td></tr>
              ) : parceirosFiltraados.map((p, i) => (
                <tr key={i} style={{ borderBottom: '1px solid #f0f0f0' }}
                  onMouseEnter={e => e.currentTarget.style.background = '#f9f9f9'}
                  onMouseLeave={e => e.currentTarget.style.background = 'white'}>
                  <td style={{ padding: '14px 16px' }}>
                    <div style={{ width: '28px', height: '28px', borderRadius: '50%', background: p.cor_primaria || '#1D9E75', border: '2px solid #eee' }} />
                  </td>
                  <td style={{ padding: '14px 16px', fontSize: '14px', fontWeight: '600' }}>{p.nome}</td>
                  <td style={{ padding: '14px 16px' }}>
                    <span style={{ background: '#EEEDFE', color: '#3C3489', padding: '4px 10px', borderRadius: '20px', fontSize: '13px', fontWeight: '700', fontFamily: 'monospace', letterSpacing: '2px' }}>
                      {p.codigo}
                    </span>
                  </td>
                  <td style={{ padding: '14px 16px', fontSize: '13px', color: '#666' }}>{p.email || '—'}</td>
                  <td style={{ padding: '14px 16px', fontSize: '13px', color: '#666' }}>{p.telefone || '—'}</td>
                  <td style={{ padding: '14px 16px', fontSize: '13px', color: '#666' }}>{p.total_clientes || 0}</td>
                  <td style={{ padding: '14px 16px' }}>
                    <span style={{ background: p.ativo ? '#E1F5EE' : '#f0f0f0', color: p.ativo ? '#0F6E56' : '#666', padding: '4px 10px', borderRadius: '20px', fontSize: '12px', fontWeight: '500' }}>
                      {p.ativo ? '🟢 Ativo' : '⚪ Inativo'}
                    </span>
                  </td>
                  <td style={{ padding: '14px 16px' }}>
                    <div style={{ display: 'flex', gap: '6px' }}>
                      <button onClick={() => abrirEditar(p)}
                        style={{ background: '#E6F1FB', color: '#185FA5', border: 'none', borderRadius: '6px', padding: '6px 10px', cursor: 'pointer', fontSize: '12px', fontWeight: '500' }}>
                        ✏️
                      </button>
                      <button onClick={() => alterarStatus(p.id, p.ativo)}
                        style={{ background: p.ativo ? '#FAEEDA' : '#E1F5EE', color: p.ativo ? '#633806' : '#0F6E56', border: 'none', borderRadius: '6px', padding: '6px 10px', cursor: 'pointer', fontSize: '12px', fontWeight: '500' }}>
                        {p.ativo ? '⏸' : '▶'}
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {modalAberto && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: 'white', borderRadius: '16px', padding: '32px', width: '600px', maxHeight: '90vh', overflowY: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
              <h2 style={{ margin: 0, color: '#333' }}>{editando ? '✏️ Editar Parceiro' : '🤝 Novo Parceiro White-Label'}</h2>
              <button onClick={fecharModal} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#999' }}>×</button>
            </div>

            <div style={{ background: '#f8f8f8', borderRadius: '8px', padding: '12px 16px', marginBottom: '20px', fontSize: '13px', color: '#666' }}>
              ℹ️ Ao criar um parceiro, será gerado automaticamente um ambiente isolado com login de administrador.
            </div>

            <h3 style={{ fontSize: '13px', color: '#1D9E75', fontWeight: '700', textTransform: 'uppercase', marginBottom: '16px' }}>Dados da Empresa</h3>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '20px' }}>
              <div style={{ gridColumn: '1/-1' }}>
                <label style={labelStyle}>Logo da Empresa</label>
                <div
                  onDragOver={e => { e.preventDefault(); setDragOver(true); }}
                  onDragLeave={() => setDragOver(false)}
                  onDrop={e => { e.preventDefault(); setDragOver(false); const f = e.dataTransfer.files[0]; if (f) uploadLogo(f); }}
                  onClick={() => document.getElementById('inputLogoParc').click()}
                  style={{ border: `2px dashed ${dragOver ? '#1D9E75' : '#ddd'}`, borderRadius: '10px', padding: '20px', textAlign: 'center', cursor: 'pointer', background: dragOver ? '#E1F5EE' : '#fafafa', transition: 'all 0.2s' }}>
                  {uploadandoLogo ? (
                    <div style={{ color: '#1D9E75', fontSize: '13px' }}>⏳ Enviando logo...</div>
                  ) : form.logo_url ? (
                    <div>
                      <img src={form.logo_url} alt="Logo" style={{ maxHeight: '60px', maxWidth: '200px', objectFit: 'contain', marginBottom: '8px' }} />
                      <div style={{ fontSize: '12px', color: '#1D9E75', fontWeight: '600' }}>✅ Logo carregada — clique para trocar</div>
                    </div>
                  ) : (
                    <div>
                      <div style={{ fontSize: '32px', marginBottom: '8px' }}>🖼️</div>
                      <div style={{ fontSize: '13px', color: '#666' }}>Clique ou arraste a logo aqui</div>
                      <div style={{ fontSize: '11px', color: '#999', marginTop: '4px' }}>JPG, PNG, SVG — máx. 2MB</div>
                    </div>
                  )}
                  <input id="inputLogoParc" type="file" accept="image/*" style={{ display: 'none' }} onChange={e => uploadLogo(e.target.files[0])} />
                </div>
              </div>
              <div>
                <label style={labelStyle}>Código de Acesso * <span style={{ color: '#999', fontWeight: '400' }}>(único)</span></label>
                <input style={{ ...inputStyle, textTransform: 'uppercase', letterSpacing: '2px', fontWeight: '700' }} value={form.codigo} onChange={e => setForm({ ...form, codigo: e.target.value.toUpperCase().replace(/\s/g, '') })} placeholder="Ex: XYZ" maxLength={10} />
              </div>
              <div>
                <label style={labelStyle}>Cor da Marca</label>
                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                  <input type="color" value={form.cor_primaria} onChange={e => setForm({ ...form, cor_primaria: e.target.value })} style={{ width: '48px', height: '42px', border: '1.5px solid #e0e0e0', borderRadius: '8px', cursor: 'pointer', padding: '2px' }} />
                  <input style={{ ...inputStyle, flex: 1 }} value={form.cor_primaria} onChange={e => setForm({ ...form, cor_primaria: e.target.value })} placeholder="#1D9E75" />
                </div>
              </div>
              <div>
                <label style={labelStyle}>Email da Empresa</label>
                <input style={inputStyle} type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} placeholder="contato@empresa.com" />
              </div>
              <div>
                <label style={labelStyle}>Telefone</label>
                <input style={inputStyle} value={form.telefone} onChange={e => setForm({ ...form, telefone: e.target.value })} placeholder="(43) 99999-9999" />
              </div>
            </div>

            <h3 style={{ fontSize: '13px', color: '#1D9E75', fontWeight: '700', textTransform: 'uppercase', marginBottom: '16px', marginTop: '8px' }}>Dados do Responsável</h3>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '20px' }}>
              <div>
                <label style={labelStyle}>Nome Fantasia</label>
                <input style={inputStyle} value={form.nome} onChange={e => setForm({ ...form, nome: e.target.value })} placeholder="Nome fantasia" />
              </div>
              <div>
                <label style={labelStyle}>Razão Social</label>
                <input style={inputStyle} value={form.razao_social} onChange={e => setForm({ ...form, razao_social: e.target.value })} placeholder="Razão social" />
              </div>
              <div>
                <label style={labelStyle}>CPF / CNPJ</label>
                <input style={inputStyle} value={form.documento} onChange={e => setForm({ ...form, documento: e.target.value })} placeholder="000.000.000-00" />
              </div>
              <div>
                <label style={labelStyle}>CEP</label>
                <input style={inputStyle} value={form.cep} onChange={e => { setForm({ ...form, cep: e.target.value }); buscarCep(e.target.value); }} placeholder="86010-000" />
              </div>
              <div style={{ gridColumn: '1/-1' }}>
                <label style={labelStyle}>Endereço</label>
                <input style={inputStyle} value={form.endereco} onChange={e => setForm({ ...form, endereco: e.target.value })} placeholder="Preenchido automaticamente pelo CEP" />
              </div>
              <div>
                <label style={labelStyle}>Número</label>
                <input style={inputStyle} value={form.numero} onChange={e => setForm({ ...form, numero: e.target.value })} placeholder="123" />
              </div>
              <div>
                <label style={labelStyle}>Complemento</label>
                <input style={inputStyle} value={form.complemento} onChange={e => setForm({ ...form, complemento: e.target.value })} placeholder="Sala 2" />
              </div>
              <div>
                <label style={labelStyle}>Bairro</label>
                <input style={inputStyle} value={form.bairro} onChange={e => setForm({ ...form, bairro: e.target.value })} placeholder="Bairro" />
              </div>
              <div>
                <label style={labelStyle}>Cidade</label>
                <input style={inputStyle} value={form.cidade} onChange={e => setForm({ ...form, cidade: e.target.value })} placeholder="Londrina" />
              </div>
              <div>
                <label style={labelStyle}>Estado</label>
                <input style={inputStyle} value={form.estado} onChange={e => setForm({ ...form, estado: e.target.value })} placeholder="PR" maxLength={2} />
              </div>
            </div>

            {!editando && (
              <>
                <h3 style={{ fontSize: '13px', color: '#1D9E75', fontWeight: '700', textTransform: 'uppercase', marginBottom: '16px' }}>Administrador do Parceiro</h3>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                  <div style={{ gridColumn: '1/-1' }}>
                    <label style={labelStyle}>Nome do Administrador *</label>
                    <input style={inputStyle} value={form.nome_admin} onChange={e => setForm({ ...form, nome_admin: e.target.value })} placeholder="Nome completo" />
                  </div>
                  <div>
                    <label style={labelStyle}>Email do Administrador *</label>
                    <input style={inputStyle} type="email" value={form.email_admin} onChange={e => setForm({ ...form, email_admin: e.target.value })} placeholder="admin@empresa.com" />
                  </div>
                  <div>
                    <label style={labelStyle}>Senha Inicial *</label>
                    <input style={inputStyle} type="password" value={form.senha_admin} onChange={e => setForm({ ...form, senha_admin: e.target.value })} placeholder="Senha de acesso" />
                  </div>
                </div>
              </>
            )}

            {form.codigo && (
              <div style={{ background: '#E1F5EE', borderRadius: '8px', padding: '12px 16px', marginTop: '20px', fontSize: '13px', color: '#0F6E56' }}>
                ✅ O parceiro vai acessar digitando o código <strong>{form.codigo}</strong> na tela de login.
              </div>
            )}

            <div style={{ display: 'flex', gap: '12px', marginTop: '24px', justifyContent: 'flex-end' }}>
              <button onClick={fecharModal} style={{ padding: '10px 20px', border: '1.5px solid #ddd', borderRadius: '8px', background: 'white', cursor: 'pointer', fontSize: '14px' }}>Cancelar</button>
              <button onClick={salvar} disabled={salvando} style={{ padding: '10px 24px', background: salvando ? '#ccc' : '#1D9E75', color: 'white', border: 'none', borderRadius: '8px', cursor: salvando ? 'not-allowed' : 'pointer', fontSize: '14px', fontWeight: '600' }}>
                {salvando ? 'Salvando...' : editando ? '✅ Salvar Alterações' : '🤝 Criar Parceiro'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Parceiros;